import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import AppModule from './app/app.module';
import { enableProdMode } from "@angular/core";
import { config } from './app/configuration/app.config';
import 'zone.js'

if (config.production) {
    enableProdMode();
  }

platformBrowserDynamic().bootstrapModule(AppModule);
